import React from 'react';

const Hero: React.FC<{ heroImage: string; heroImageAltText: string }> = ({
  heroImage,
  heroImageAltText,
}) => {
  return (
    <div className="width-full pad-0 tw-max-w-360">
      <img
        className="md_tw-rounded-2xl"
        src={heroImage}
        alt={heroImageAltText}
      />
    </div>
  );
};

export default Hero;
